import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import apiClient from '../services/api';

const CallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, user } = useAuthStore();

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const error = params.get('error');

      // Извлекаем провайдер из пути
      const pathParts = location.pathname.split('/');
      const provider = pathParts[pathParts.indexOf('auth') + 1] as 'google' | 'yandex' | 'vk';

      if (error) {
        console.error('OAuth error:', error);
        navigate('/login?error=auth_failed');
        return;
      }

      if (!code) {
        console.error('No authorization code');
        navigate('/login?error=no_code');
        return;
      }

      try {
        await login(provider, code);
        
        // Проверяем, есть ли отложенное отслеживание
        const trackingData = sessionStorage.getItem('pending_organizer_tracking');
        if (trackingData && user) {
          try {
            const { organizer_id, utm_source, utm_medium, utm_campaign } = JSON.parse(trackingData);
            
            // Отправляем данные о регистрации
            await apiClient.post('/api/organizers/track/registration', {
              organizer_user_id: organizer_id,
              user_id: user.id,
              utm_source,
              utm_medium,
              utm_campaign,
            });
            
            // Очищаем отложенные данные
            sessionStorage.removeItem('pending_organizer_tracking');
            
            // Перенаправляем на мероприятия организатора
            navigate(`/events?organizer_id=${organizer_id}`, { replace: true });
            return;
          } catch (err) {
            console.error('Failed to track registration:', err);
          }
        }
        
        navigate('/events', { replace: true });
      } catch (err) {
        console.error('Login failed:', err);
        navigate('/login?error=login_failed');
      }
    };

    handleCallback();
  }, [location, navigate, login, user]);
  
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>
      <div style={{ textAlign: 'center' }}>
        <div className="spinner" style={{ 
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3390ec',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 20px'
        }} />
        <p>Завершение авторизации...</p>
      </div>
    </div>
  );
};

export default CallbackPage;
